import React, {Dispatch, SetStateAction, useState} from 'react';
import StyledPaper from './shared/StyledPaper';
import {
  Button,
  Container,
  Grid,
  Slider, TextField,
  Typography,
} from '@material-ui/core';
import styled from 'styled-components';
import npsService from '../services/npsService';
import {useParams} from 'react-router';
import StyledSnackbar from './shared/StyledSnackbar';

const StyledSlider = styled(Slider)`
margin-bottom: 30px;
`;

const Arrows = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
margin-top: 20px;
margin-bottom: -10px;
font-size: 30px;
color: #2196f3;
`;

/**
 * Mobile version of Rate component
 * @param question - interview question
 * @param rated - callback

 * @constructor
 */
const RateMobile = ({question, rated}: { question: string, rated: any }) => {
  const {hash} = useParams();
  const marks = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(v => {
    return {
      value: v,
      label: v.toString(),
    };
  });

  const [rate, setRate]: [number | null, Dispatch<SetStateAction<any>>] = useState(
      6);
  const [showError, setError]: [boolean, Dispatch<SetStateAction<any>>] = useState(
      false);
  const [buttonDisabled, setDisabled]: [boolean, Dispatch<SetStateAction<any>>] = useState(
      true);
  const [comment, setComment]: [string | undefined, Dispatch<SetStateAction<any>>] = useState();

  let commentBlock = null;
  if (rate > 0 && rate < 7) {
    commentBlock = (
        <Grid item xs={12}>
          <TextField onChange={e => setComment(e.target.value)} label={'Комментарий'}
                     focused fullWidth variant={'outlined'} multiline
                     placeholder={'Что бы вы хотели изменить?'}
          />
        </Grid>
    );
  }

  const valuetext = (val: number) => {
    if (val < 7) return '😢';
    if (val < 9) return '🙂';
    return '😍';
  };

  const valueChanged = (val: number | number[]) => {
    setDisabled(false);
    setRate(val);
  };

  const sendRate = async () => {
    try {
      setDisabled(true);
      await npsService.postNpsRate(+rate, hash, comment);
      rated(rate);
    } catch (e) {
      setDisabled(false);
      setError(true);
    }
  };

  return (
      <Grid container direction={'column'} spacing={2}>
        <Grid container item xs={12}>
          <StyledPaper>
            <Typography align={'center'}>
              {question}
            </Typography>
          </StyledPaper>
        </Grid>

        <Grid container item xs={12}>
          <StyledPaper>
            <Typography align={'center'} variant={'h5'}>
              {rate}
            </Typography>
          </StyledPaper>
        </Grid>

        <Grid container item xs={12}>
          <Container>
            <Arrows>
              <span>&larr;</span>
              <span>&rarr;</span>
            </Arrows>
            <StyledSlider
                value={rate}
                onChange={(e, val) => valueChanged(val)}
                getAriaValueText={valuetext}
                valueLabelFormat={valuetext}
                step={1}
                marks={marks}
                valueLabelDisplay="on"
                min={1}
                max={10}
            />
          </Container>

        </Grid>

        {commentBlock}

        <Grid container item xs={12}>
          <Button disabled={buttonDisabled} size={'large'} fullWidth={true}
                  variant={'contained'} color={'primary'}
                  onClick={sendRate}>Оценить</Button>
        </Grid>

        <StyledSnackbar visible={showError} severity={'warning'}
                        onClose={() => setError(false)}/>
      </Grid>
  );
};

export default RateMobile;
